import { Activities } from './Activities'
import { BaseCall } from './BaseCall'
import { Channels } from './Channels'
import { ChannelsAdmin } from './ChannelsAdmin'
import { Countries } from './Countries'
import { Groups } from './Groups'
import { APIConfig, AdditionalHeaders } from './interfaces'
import { LynxVnc } from './LynxVnc'
import { Logs } from './Logs'
import { ObjectStore } from './ObjectStore'
import { Organisations } from './Organisations'
import { Pages } from './Pages'
import { Profanity } from './Profanity'
import { Reports } from './Reports'
import { Search } from './Search'
import { User } from './User'
import { UserSessions } from './UserSessions'
import { Translator } from './Translator'
import { Translation } from './Translation'
import { Convert } from './Convert'
import { Share } from './Share'
import { Feedback } from './Feedback'
import { DisplayName } from './DisplayName'
import { Newsletter } from './Newsletter'
import { Sharing } from './Sharing'
import { Url } from './Url/Url'
import { Notifications } from './Notifications'
import { OpenTDB } from './OpenTDB'
import { Sites } from './Sites'
import { Ai } from './Ai'
import { Favourites } from './Favourites'
import { Billing } from './Billing/Billing'
import { AdminOAuthProjects, PartnerOAuthProjects } from './OAuthProjects'
import axios from 'axios'

class Requests {
	protected activities: Activities = new Activities()
	protected ai: Ai = new Ai()
	protected basecall: BaseCall = new BaseCall()
	protected billing: Billing = new Billing()
	protected channels: Channels = new Channels()
	protected channelsadmin: ChannelsAdmin = new ChannelsAdmin()
	protected convert: Convert = new Convert()
	protected countries: Countries = new Countries()
	protected displayName: DisplayName = new DisplayName()
	protected feedback: Feedback = new Feedback()
	protected groups: Groups = new Groups()
	protected logs: Logs = new Logs()
	protected lynxVnc: LynxVnc = new LynxVnc()
	protected newsletter: Newsletter = new Newsletter()
	protected notifications: Notifications = new Notifications()
	protected objectstore: ObjectStore = new ObjectStore()
	protected openTDB: OpenTDB = new OpenTDB()
	protected organisation: Organisations = new Organisations()
	protected pages: Pages = new Pages()
	protected profanity: Profanity = new Profanity()
	protected reports: Reports = new Reports()
	protected search: Search = new Search()
	protected share: Share = new Share()
	protected sharing: Sharing = new Sharing()
	protected sites: Sites = new Sites()
	protected translation: Translation = new Translation()
	protected translator: Translator = new Translator()
	protected url: Url = new Url()
	protected user: User = new User()
	protected userSessions: UserSessions = new UserSessions()
	protected favourites: Favourites = new Favourites()
	protected adminOAuthProjects: AdminOAuthProjects = new AdminOAuthProjects()
	protected partnerOAuthProjects: PartnerOAuthProjects = new PartnerOAuthProjects()
	public config: APIConfig | null = null
	private accessToken: string = ''

	public getAccessToken(): string {
		return this.accessToken
	}

	private reqNames = [
		'activities',
		'ai',
		'billing',
		'channels',
		'channelsadmin',
		'convert',
		'countries',
		'displayName',
		'feedback',
		'groups',
		'logs',
		'lynxVnc',
		'newsletter',
		'notifications',
		'objectstore',
		'organisation',
		'pages',
		'profanity',
		'reports',
		'search',
		'share',
		'sharing',
		'sites',
		'translation',
		'translator',
		'url',
		'user',
		'UserSessions',
		'favourites',
		'adminOAuthProjects',
		'partnerOAuthProjects'
	] as const

	public setAuthorization(token: string): void {
		this.reqNames.forEach((reqName) => {
			this[reqName].setAuthorization(token)
		})
		this.accessToken = token
	}

	public setConfig(config: APIConfig): void {
		this.reqNames.forEach((reqName) => {
			this[reqName].setConfig(config)
		})
		this.config = config
	}

	public setDefaultHeaders(additionalHeaders: AdditionalHeaders): void {
		this.reqNames.forEach((reqName) => {
			this[reqName].setDefaultHeaders(additionalHeaders)
		})
	}

	public setRequestInterceptor(...interceptor: Parameters<typeof axios.interceptors.response.use>): void {
		this.reqNames.forEach((reqName) => {
			this[reqName].setRequestInterceptor(...interceptor)
		})
	}

	public setRequestParams(paramsData: Record<string, any>): void {
		this.reqNames.forEach((reqName) => {
			this[reqName].setRequestParams(paramsData)
		})
	}

	get Activities(): Activities {
		return this.activities
	}

	get Billing(): Billing {
		return this.billing
	}

	get Convert(): Convert {
		return this.convert
	}

	get LynxVnc(): LynxVnc {
		return this.lynxVnc
	}

	get Countries(): Countries {
		return this.countries
	}

	get Sharing(): Sharing {
		return this.sharing
	}

	get Url(): Url {
		return this.url
	}

	get User(): User {
		return this.user
	}

	get Favourites(): Favourites {
		return this.favourites
	}

	get Feedback(): Feedback {
		return this.feedback
	}

	get Sites(): Sites {
		return this.sites
	}

	get Groups(): Groups {
		return this.groups
	}

	get Logs(): Logs {
		return this.logs
	}

	get Profanity(): Profanity {
		return this.profanity
	}

	get ObjectStore(): ObjectStore {
		return this.objectstore
	}

	get Organisations(): Organisations {
		return this.organisation
	}

	get Pages(): Pages {
		return this.pages
	}

	get Reports(): Reports {
		return this.reports
	}

	get Search(): Search {
		return this.search
	}

	get Share(): Share {
		return this.share
	}

	get Channels(): Channels {
		return this.channels
	}

	get ChannelsAdmin(): ChannelsAdmin {
		return this.channelsadmin
	}

	get Translator(): Translator {
		return this.translator
	}

	get DisplayName(): DisplayName {
		return this.displayName
	}

	get Newsletter(): Newsletter {
		return this.newsletter
	}

	get Notifications(): Notifications {
		return this.notifications
	}

	get OpenTDB(): OpenTDB {
		return this.openTDB
	}

	get Ai(): Ai {
		return this.ai
	}

	get Translation(): Translation {
		return this.translation
	}
	get UserSessions(): UserSessions {
		return this.userSessions
	}

	get AdminOAuthProjects(): AdminOAuthProjects {
		return this.adminOAuthProjects
	}

	get PartnerOAuthProjects(): PartnerOAuthProjects {
		return this.partnerOAuthProjects
	}
}

export const ApiInstance = (): Requests => new Requests()
export const APIRequest = new Requests()
APIRequest.setDefaultHeaders({})
